export const homeMenuList = [
  {
    name: "工作台",
    acIcon: "worktableAcIcon",
    icon: "worktableIcon",
    code: "worktable",
    isMenu: true,
    router_path: "/home/worktable",
  },
  {
    name: "文件管理",
    acIcon: "fileManagementAcIcon",
    icon: "fileManagementIcon",
    code: "file_management",
    isMenu: true,
    router_path: "/home/file_management",
  },
  {
    name: "文件借阅",
    acIcon: "documentBorrowingAcIcon",
    icon: "documentBorrowingIcon",
    code: "document_borrowing",
    isMenu: true,
    router_path: "/home/document_borrowing",
  },
  {
    name: "文件归还",
    acIcon: "documentReturnAcIcon",
    icon: "documentReturnIcon",
    code: "document_return",
    isMenu: true,
    router_path: "/home/document_return",
  },
  {
    name: "文件出库",
    acIcon: "documentOutboundAcIcon",
    icon: "documentOutboundIcon",
    code: "document_outbound",
    isMenu: true,
    router_path: "/home/document_outbound",
  },
  {
    name: "在位监控",
    acIcon: "documentinventoryAcIcon",
    icon: "documentinventoryIcon",
    code: "document_inventory",
    isMenu: true,
    router_path: "/home/document_inventory",
  },
  {
    name: "告警管理",
    acIcon: "alarmAcIcon",
    icon: "alarmIcon",
    code: "alarm_management",
    isMenu: false,
    children: [
      {
        name: "文件告警",
        acIcon: "alarmAcIcon",
        icon: "alarmIcon",
        code: "file_alarm",
        isMenu: true,
        router_path: "/home/file_alarm",
      },
      {
        name: "柜子告警",
        acIcon: "alarmAcIcon",
        icon: "alarmIcon",
        code: "cabinet_alarm",
        isMenu: true,
        router_path: "/home/cabinet_alarm",
      },
    ],
  },
  {
    name: "管控管理",
    acIcon: "trackAcIcon",
    icon: "trackIcon",
    code: "file_track",
    isMenu: false,
    children: [
      {
        name: "管控记录",
        acIcon: "trackAcIcon",
        icon: "trackIcon",
        code: "file_track",
        isMenu: true,
        router_path: "/home/file_track",
      },
      {
        name: "管控报告",
        acIcon: "trackAcIcon",
        icon: "trackIcon",
        code: "file_track",
        isMenu: true,
        router_path: "/home/control_report",
      },
    ],
  },
  {
    name: "待办事项",
    acIcon: "toDoListAcIcon",
    icon: "toDoListIcon",
    code: "to_do_list",
    isMenu: true,
    router_path: "/home/to_do_list",
  },
  {
    name: "人员管理",
    acIcon: "personnelManagementAcIcon",
    icon: "personnelManagementIcon",
    code: "personnel_management",
    isMenu: true,
    router_path: "/home/personnel_management",
  },
  {
    name: "部门管理",
    acIcon: "deptAcIcon",
    icon: "deptIcon",
    code: "dept",
    isMenu: true,
    router_path: "/home/dept_management",
  },
  {
    name: "柜子管理",
    acIcon: "cabinetAcIcon",
    icon: "cabinetIcon",
    code: "cabinet_info",
    isMenu: false,
    children: [
      {
        name: "柜子信息",
        acIcon: "cabinetAcIcon",
        icon: "cabinetIcon",
        code: "cabinet_info",
        isMenu: true,
        router_path: "/home/cabinet_info",
      },
      {
        name: "柜子日志",
        acIcon: "cabinetAcIcon",
        icon: "cabinetIcon",
        code: "cabinet_log_alarm",
        isMenu: true,
        router_path: "/home/cabinet_log_alarm",
      },
    ],
  },
  {
    name: "字典管理",
    acIcon: "dictAcIcon",
    icon: "dictIcon",
    code: "dict",
    isMenu: true,
    router_path: "/home/dict_management",
  },
];
export const secadmMenuList = [
  {
    name: "账户管理",
    acIcon: "mgrAcIcon",
    icon: "mgrIcon",
    code: "mgr",
    isMenu: true,
    router_path: "/home/user_management",
  },
  {
    name: "安全审计管理员日志",
    acIcon: "auditLogAcIcon",
    icon: "auditLogIcon",
    code: "dict",
    isMenu: true,
    router_path: "/home/audit_log",
  },
  {
    name: "普通用户日志",
    acIcon: "baseLogAcIcon",
    icon: "baseLogIcon",
    code: "dict",
    isMenu: true,
    router_path: "/home/base_log",
  },
  {
    name: "常规配置",
    acIcon: "configAcIcon",
    icon: "configIcon",
    code: "dict",
    isMenu: true,
    router_path: "/home/system_config",
  },
];
export const sysadminMenuList = [
  {
    name: "账户管理",
    acIcon: "mgrAcIcon",
    icon: "mgrIcon",
    code: "mgr",
    isMenu: true,
    router_path: "/home/user_management",
  },
  {
    name: "角色管理",
    acIcon: "roleAcIcon",
    icon: "roleIcon",
    code: "role",
    isMenu: true,
    router_path: "/home/role_management",
  },
];
export const auditMenuList = [
  {
    name: "安全保密管理员日志",
    acIcon: "secadmLogAcIcon",
    icon: "secadmLogIcon",
    code: "dict",
    isMenu: true,
    router_path: "/home/secadm_log",
  },
  {
    name: "系统管理员日志",
    acIcon: "systemAcIcon",
    icon: "systemIcon",
    code: "dict",
    isMenu: true,
    router_path: "/home/sysadmin_log",
  },
];



// WEBPACK FOOTER //
// ./src/common/utils/menu_list.js